<template>
  <div ref="playani"></div>
</template>

<script>
import lottie from 'lottie-web'
const animationData = require('./play.json');
export default {
  mounted() {
    this.initLottie();
  },
  methods: {
    initLottie() {
      lottie.loadAnimation({
        container: this.$refs.playani,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: animationData,
      });
    }
  }
}
</script>